import { lazy, Suspense } from "react";
import PropTypes from "prop-types";

import AlgoliaSearchWrapper from "components/AlgoliaSearchWrapper";
import CategoryPresenter from "presenters/CategoryPresenter";
import RichTextFooter from "components/RichTextFooter";
import SearchBoxGeneric from "components/SearchBoxGeneric";
import SearchResults from "components/SearchResults";
import Categories from "components/Categories";

const StarringYouCards = lazy(() => import("components/StarringYouCards"));

const Content = ({ category, initialUiState, indexName }) => {
  const allTitle = CategoryPresenter.renderCategoryName(category);
  const footer = CategoryPresenter.footer(category);
  const searchResultsSkeletonSlot = (
    <Suspense fallback={<span />}>
      <StarringYouCards loading />
    </Suspense>
  );

  return (
    <AlgoliaSearchWrapper proxy={false} context="invites" initialUiState={initialUiState}>
      <SearchBoxGeneric
        initialQueryObject={initialUiState?.[indexName]}
        searchResultsSkeletonSlot={searchResultsSkeletonSlot}
        resultsSlot={SearchResults}
        resultsSlotProps={{
          title: allTitle,
          WrappedComponent: StarringYouCards,
          showDetails: true,
          shouldTrackAlgoliaAnalytics: true,
        }}
      />
      <RichTextFooter richText={footer} />
      <Categories isDescriptionVisible={false} />
    </AlgoliaSearchWrapper>
  );
};

Content.propTypes = {
  category: PropTypes.shape(),
  initialUiState: PropTypes.shape(),
  indexName: PropTypes.string,
};

export default Content;
